import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./actionReport.module.css";
import userInfoStyles from "../userInfo/userInfo.module.css";
import CreatableSelect from "react-select/creatable";
import {
  filterLastOfEachGroup,
  getSelectNote,
  isFormValid,
  noDataLabel,
  TGrouppedQuestionsOptions,
  TLabeledQuestionOption,
  transformServerOptions,
} from "../../utils/constants";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Select, { ActionMeta, MultiValue } from "react-select";
import Modal from "../modals/modal/Modal";
import GeneralSuccessPopup from "../modals/generalSuccessPopup/generalSuccessPopup";
import {
  useLazyGetDefaultReportDataQuery,
  useInsertAllAnswersQuestionsMutation,
  useLazyGetReportQuestionsAndOptionsByQuestionnaireIdQuery,
  useLazyGetQuestionnaireAnswersForEditQuery,
  useGetTherapistQuestionnairesForAutoFillQuery,
  useGetAllQuestionnairesByUserIdQuery,
} from "../../services/api/user.api";
import BackArrowButton from "../backArrowButton/backArrowButton";
import Loader from "../loader/loader";
import ErrorPopup from "../modals/errorPopup/errorPopup";
import {
  TInsertAllAnswersRequest,
  TGetQuestionnaireAnswersForEditResponse,
  TTherapistQuestionnaireForAutoFill,
} from "../../services/types/user.types";
import { useAppSelector } from "../../services/hooks";
import { adminSelector } from "../../services/selectors/user.selectors";

import UserInfo from "../userInfo/userInfo";
import useAutosizeTextArea from "../../hooks/useAutosizeTextarea";
import {
  IUserReport,
  TDefaultReportData,
} from "../../services/types/users.types";
import { canAddDefaultReportsSelector, isChargingCustomersSelector } from "../../services/selectors/auth.selectors";
import PaymentSection from "../paymentSection";
import { useUpdateQuestionnaireScoreTotalAmountMutation } from "../../services/api/payment.api";
import { useGetCompanyByIdQuery } from "../../services/api/utils.api";
import { paymentSessionSelector } from "../../services/selectors/paymentSession.selectors";
import { useActions } from "../../services/hooks/useActions";
import PaymentPopup from "../paymentPopup/paymentPopup";
import { IAppointmentsProgram } from "../../services/types/utils.types";
import { TUpdateQuestionnaireScoreTotalAmountRequest } from "../../services/types/payment.types";

type TQuestionnaireSwitcherOption = {
  value: number;
  label: string;
  questionnaire?: TTherapistQuestionnaireForAutoFill;
};

const questionnaireSwitcherStyles = {
  container: (base: any) => ({ ...base, flex: 1, minWidth: 0 }),
  control: (base: any, state: any) => ({
    ...base,
    minHeight: "40px",
    borderRadius: "8px",
    borderColor: state.isFocused ? "#2684FF" : "#ccc",
    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
  }),
  menu: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any) => ({ ...base, fontSize: "14px", cursor: "pointer" }),
};

function ActionReport({
  user,
  onClose,
  initialQuestionnaireId = null,
  initialQuestionnaireCompaniesId = null,
  initialCycle = null,
  initialDefaultName,
  initialQuestionnaireCompaniesScoreUsersId = null,
  initialTherapistsGuid,
}: {
  user: IUserReport;
  onClose: () => void;
  initialQuestionnaireId?: number | null;
  initialQuestionnaireCompaniesId?: number | null;
  initialCycle?: number | null;
  initialDefaultName?: string;
  initialQuestionnaireCompaniesScoreUsersId?: number | null;
  initialTherapistsGuid?: string | null;
}) {
  const textAreaRefs = useRef<{ [key: string]: HTMLTextAreaElement | null }>({});
  const admin = useAppSelector(adminSelector);
  const paymentSession = useAppSelector(paymentSessionSelector);
  const { sessionPrice, selectedServiceId, selectedQuestionnaireScoreStatusId } = paymentSession;
  const canAddDefaultReports = useAppSelector(canAddDefaultReportsSelector);


  // Show payment buttons if company is charging customers
  const showPaymentFeatures = useAppSelector(isChargingCustomersSelector);
  const treatmentPlanServiceId = null; //add treatment plan service id logic
  const { setPaymentService, setSessionPrice, setPendingPayment, setSelectedQuestionnaireScoreStatus } = useActions();
  //get company details to check if it is charging company
  useGetCompanyByIdQuery(
    admin.companyId,
    { skip: !admin.companyId || admin.companyId === 0 }
  );



  // console.log(user, admin.guid, initialTherapistsGuid);
  const [
    GetReportQuestionsAndOptions,
    { data: reportQuestionsAndOptionData, isLoading, isError },
  ] = useLazyGetReportQuestionsAndOptionsByQuestionnaireIdQuery();
  const [insertAllAnswers, { isLoading: isSending }] =
    useInsertAllAnswersQuestionsMutation();
  const [getDefaultData] = useLazyGetDefaultReportDataQuery();
  const [getQuestionnaireAnswersForEdit] = useLazyGetQuestionnaireAnswersForEditQuery();
  const [updateQuestionnaireScoreTotalAmount] = useUpdateQuestionnaireScoreTotalAmountMutation();

  const [reportInitialInfo, setReportInitialInfo] = React.useState<
    TDefaultReportData | undefined
  >(undefined);
  const [openModal, setOpenModal] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [error, setError] = useState<boolean | string>(false);
  const [formValid, setFormValid] = useState<boolean>(false);
  const [savedTreatmentPlan, setSavedTreatmentPlan] = useState<Partial<IAppointmentsProgram> | null>(null);
  const [selectedOptions, setSelectedOptions] = useState<{
    [key: string]: {
      options: TLabeledQuestionOption[];
      isValid: boolean;
      min: number | null;
      touched: boolean;
      answer?: string;
    };
  }>({});
  const [submittedScoreUsersId, setSubmittedScoreUsersId] = useState<number | undefined>(undefined);
  const [sendQuestionnaireCompaniesScoreUpdate, setSendQuestionnaireCompaniesScoreUpdate] = useState(true);
  const [checkboxValues, setCheckboxValues] = useState<Record<string, boolean>>({});
  const [editAnswersData, setEditAnswersData] = useState<TGetQuestionnaireAnswersForEditResponse | null>(null);
  const [initialPaymentFromEdit, setInitialPaymentFromEdit] = useState<{
    totalAmount: number;
    companyServiceId: number;
    questionnaireScoreStatusId?: number | null;
  } | null>(null);
  const [pendingEditPayment, setPendingEditPayment] = useState<{
    companyServiceId: number;
    totalAmount: number;
  } | null>(null);

  const transformedOptions = useMemo(() => {
    if (!reportQuestionsAndOptionData) return {};
    return reportQuestionsAndOptionData.reduce((acc, question) => {
      acc[question.Questions.Id] = transformServerOptions(
        question.QuestionsOptions,
        question.Questions.OptionsCountMax,
        question.Questions.OptionsCountMin
      );
      return acc;
    }, {} as Record<number, Array<TGrouppedQuestionsOptions | TLabeledQuestionOption>>);
  }, [reportQuestionsAndOptionData]);

  // Questionnaire switcher - the questionnaires this company exposes to staff.
  // Hidden while reopening a saved report: its answers are already filed under one questionnaire.
  const isEditingExistingReport = initialQuestionnaireCompaniesScoreUsersId != null;

  const { data: availableQuestionnaires, isLoading: isLoadingQuestionnaires } =
    useGetTherapistQuestionnairesForAutoFillQuery(undefined, {
      skip: isEditingExistingReport,
    });

  // This patient's reports. Submitting invalidates the "questionnaires" tag, so the list
  // stays current while the form is open and the cycle below resolves off fresh data.
  const { data: allUserQuestionnaires } = useGetAllQuestionnairesByUserIdQuery(
    { guid: user.Users.Guid || "" },
    { skip: isEditingExistingReport || !user.Users.Guid }
  );

  // The cycle a report under this questionnaire + component belongs to: one past the
  // patient's last one, which is the rule the server applies when no cycle is sent.
  // null when the history hasn't arrived - the server then works it out itself. Never
  // guess: a cycle that already exists makes it delete the answers filed under it.
  const nextCycleFor = useCallback(
    (questionnaireId: number, questionnaireCompaniesId: number) => {
      if (!allUserQuestionnaires) return null;
      return (
        [
          ...(allUserQuestionnaires.QuestionnairesUsers ?? []),
          ...(allUserQuestionnaires.QuestionnairesTherapists ?? []),
        ]
          .filter(
            (r) =>
              r.QuestionnaireId === questionnaireId &&
              r.QuestionnaireCompaniesId === questionnaireCompaniesId
          )
          .reduce((max, r) => Math.max(max, r.Cycle ?? 0), 0) + 1
      );
    },
    [allUserQuestionnaires]
  );

  const questionnaireOptions: TQuestionnaireSwitcherOption[] = useMemo(
    () =>
      (availableQuestionnaires ?? []).map((q) => ({
        value: q.questionnaireId,
        label: q.typeName ? `${q.name} (${q.typeName})` : q.name,
        questionnaire: q,
      })),
    [availableQuestionnaires]
  );

  const selectedQuestionnaireOption: TQuestionnaireSwitcherOption | null =
    useMemo(() => {
      if (!reportInitialInfo) return null;
      return (
        questionnaireOptions.find(
          (o) => o.value === reportInitialInfo.QuestionnaireId
        ) ?? {
          value: reportInitialInfo.QuestionnaireId,
          label: reportInitialInfo.DefaultName || t(noDataLabel),
        }
      );
    }, [questionnaireOptions, reportInitialInfo]);

  const handleQuestionnaireChange = useCallback(
    (option: TQuestionnaireSwitcherOption | null) => {
      const questionnaire = option?.questionnaire;
      if (
        !questionnaire ||
        questionnaire.questionnaireId === reportInitialInfo?.QuestionnaireId
      ) {
        return;
      }

      // A questionnaire can belong to several components, so keep the current one when it still applies.
      const currentCompaniesId = reportInitialInfo?.QuestionnaireCompaniesId;
      const linkedCompaniesIds = questionnaire.questionnaireCompaniesIds ?? [
        questionnaire.questionnaireCompaniesId,
      ];
      const nextCompaniesId =
        currentCompaniesId != null &&
        linkedCompaniesIds.includes(currentCompaniesId)
          ? currentCompaniesId
          : questionnaire.questionnaireCompaniesId;

      // Answers belong to the previous questionnaire's questions - start the form clean.
      setSelectedOptions({});
      setCheckboxValues({});
      setFormValid(false);
      setSavedTreatmentPlan(null);

      setReportInitialInfo((prev) => ({
        QuestionnaireCompaniesId: nextCompaniesId,
        QuestionnaireId: questionnaire.questionnaireId,
        Cycle: nextCycleFor(questionnaire.questionnaireId, nextCompaniesId),
        DefaultName: questionnaire.name,
        // Company-level permission, not a property of the questionnaire - keep it.
        AllowTherapistToSeeAiAnalysis: prev?.AllowTherapistToSeeAiAnalysis,
      }));
      GetReportQuestionsAndOptions(questionnaire.questionnaireId);
    },
    [reportInitialInfo, nextCycleFor, GetReportQuestionsAndOptions]
  );

  // Check if payment fields are valid when payment features are enabled
  const isPaymentValid = useMemo(() => {
    if (!showPaymentFeatures) return true;
    return selectedServiceId !== null && sessionPrice >= 0;
  }, [showPaymentFeatures, selectedServiceId, sessionPrice]);


  const sendForm = () => {
    let payload: TInsertAllAnswersRequest[] = [];
    reportInitialInfo &&
      Object.keys(selectedOptions).map((k) =>
        payload.push({
          Id: "0",
          QuestionnaireId: reportInitialInfo.QuestionnaireId.toString() ?? "0",
          QuestionsId: k,
          Answer: selectedOptions[k].answer ?? "",
          AnswerDate: null,
          QuestionsOptionsIds: selectedOptions[k].options
            .map((option) => option.Id.toString())
            .join(", "),
          Cycle: reportInitialInfo.Cycle ?? null,
        })
      );

    insertAllAnswers({
      answers: payload,
      questionnaireCompaniesId:
        reportInitialInfo?.QuestionnaireCompaniesId ?? -1,
      targetUserGuid: user.Users.Guid || "0",
      questionnaireCompaniesScoreUsersId: submittedScoreUsersId,

    }).then(async (res) => {
      if ("data" in res) {
        const scoreUsersId = res?.data?.questionnaireCompaniesScoreUsersId;
        // Store the scoreUsersId for later use (payment)
        setSubmittedScoreUsersId(scoreUsersId);

        // If company can charge and payment section values are set, send them to server
        if (sendQuestionnaireCompaniesScoreUpdate && showPaymentFeatures && scoreUsersId && sessionPrice >= 0 && selectedServiceId) {
          try {
            await updateQuestionnaireScoreTotalAmount({
              id: scoreUsersId,
              body: {
                totalAmount: sessionPrice,
                companyServiceId: selectedServiceId,
                questionnaireCompaniesScoreUsersStatusesId: selectedQuestionnaireScoreStatusId,
              },
            }).unwrap();
          } catch (updateError) {
            console.error("Failed to update questionnaire score with payment info:", updateError);
          }
        }

        // If there's a pending payment, trigger it now with the scoreUsersId
        // If company is charging, open PaymentModal after successful submission
        if (false) {
          // if (showPaymentFeatures && scoreUsersId) {disable payment modal for now
          setOpenPaymentModal(true);
        } else {
          setOpenModal(true);
        }
      } else {
        setError(true);
      }
    });
  };
    // Auto-resize all textareas (DataTypesId === 2) when their values change
    useEffect(() => {
      reportQuestionsAndOptionData?.forEach((question) => {
        if (question.Questions.DataTypesId === 2) {
          const questionId = question.Questions.Id.toString();
          const textAreaElement = textAreaRefs.current[questionId];
          const answerValue = selectedOptions[questionId]?.answer || "";
          
          if (textAreaElement) {
            textAreaElement.style.height = "0px";
            const scrollHeight = textAreaElement.scrollHeight;
            textAreaElement.style.height = scrollHeight + "px";
          }
        }
      });
    }, [reportQuestionsAndOptionData, selectedOptions]);
  

  useEffect(() => {
    if (isError) {
      setError(true);
    }
  }, [isError]);
  useEffect(() => {
    if (!user.Users.Guid) {
      setError(t("USER_GUID_ERROR"));
    }
  }, [user]);

  useEffect(() => {
    if (initialQuestionnaireCompaniesScoreUsersId != null) {
      setSubmittedScoreUsersId(initialQuestionnaireCompaniesScoreUsersId);
      getQuestionnaireAnswersForEdit(initialQuestionnaireCompaniesScoreUsersId).then((res) => {
        if ("data" in res && res.data) {
          setEditAnswersData(res.data);
        }
      });
    }
  }, [initialQuestionnaireCompaniesScoreUsersId, getQuestionnaireAnswersForEdit]);

  // Pre-fill payment section from GetQuestionnaireAnswersForEdit as soon as we have the data
  // (runs even when report questions haven't loaded or Questions array is empty)
  useEffect(() => {
    if (!editAnswersData || !showPaymentFeatures) return;

    const hasPayment =
      editAnswersData.CompanyServiceId != null &&
      editAnswersData.TotalAmount !== undefined &&
      editAnswersData.TotalAmount !== null;
    if (hasPayment) {
      const totalAmount = editAnswersData.TotalAmount as number;
      const companyServiceId = editAnswersData.CompanyServiceId!;
      setInitialPaymentFromEdit({
        totalAmount,
        companyServiceId,
        ...(editAnswersData.QuestionnaireCompaniesScoreUsersStatusesId != null && {
          questionnaireScoreStatusId: editAnswersData.QuestionnaireCompaniesScoreUsersStatusesId,
        }),
      });
      const serviceOption = paymentSession.serviceOptions?.find(
        (opt) => opt.service?.serviceId === companyServiceId
      );
      if (serviceOption) {
        setPaymentService({
          serviceId: companyServiceId,
          serviceName: serviceOption.service.serviceName,
          price: totalAmount,
        });
        setPendingEditPayment(null);
      } else {
        setSessionPrice(totalAmount);
        setPendingEditPayment({
          companyServiceId,
          totalAmount,
        });
      }
    }
    if (editAnswersData.QuestionnaireCompaniesScoreUsersStatusesId != null) {
      setSelectedQuestionnaireScoreStatus(editAnswersData.QuestionnaireCompaniesScoreUsersStatusesId);
    }
    // Clear so we don't re-run when there are no form questions to pre-fill
    if (!editAnswersData.Questions?.length) {
      setEditAnswersData(null);
    }
  }, [
    editAnswersData,
    showPaymentFeatures,
    paymentSession.serviceOptions,
    setPaymentService,
    setSessionPrice,
    setSelectedQuestionnaireScoreStatus,
  ]);

  // Callers rebuild the `user` prop on every render, so this effect can re-run at any
  // time. Initialise once per patient + entry point: re-running would reset the report
  // to the default questionnaire and throw away a switch the user made below.
  const initializedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const guid = user.Users.Guid;
    if (!guid) return;

    const initKey = JSON.stringify([
      guid,
      initialQuestionnaireId,
      initialQuestionnaireCompaniesId,
      initialCycle,
      initialDefaultName,
    ]);
    if (initializedKeyRef.current === initKey) return;
    initializedKeyRef.current = initKey;

    if (
      initialQuestionnaireId != null &&
      initialQuestionnaireCompaniesId != null
    ) {
      setReportInitialInfo({
        QuestionnaireId: initialQuestionnaireId,
        QuestionnaireCompaniesId: initialQuestionnaireCompaniesId,
        Cycle: initialCycle,
        DefaultName: initialDefaultName ?? "",
      });
      GetReportQuestionsAndOptions(initialQuestionnaireId);
      return;
    }

    getDefaultData(guid).then((res) => {
      if (
        "data" in res &&
        res.data?.DefaultReportData[0]?.QuestionnaireCompaniesId
      ) {
        const data = res.data.DefaultReportData[0];
        setReportInitialInfo({
          ...data,
          Cycle: data.Cycle ? data.Cycle + 1 : 1,
        });
        GetReportQuestionsAndOptions(data.QuestionnaireId);
      } else {
        setError(true);
      }
    });
  }, [
    user,
    getDefaultData,
    GetReportQuestionsAndOptions,
    initialQuestionnaireId,
    initialQuestionnaireCompaniesId,
    initialCycle,
    initialDefaultName,
  ]);

  useEffect(() => {
    if (reportQuestionsAndOptionData) {
      reportQuestionsAndOptionData.forEach((question) => {
        if (question.Questions.OptionsCountMin) {
          setSelectedOptions((prev) => ({
            ...prev,
            [question.Questions.Id]: {
              options: [],
              isValid: false,
              min: question.Questions.OptionsCountMin,
              touched: false,
            },
          }));
        }
        // checkbox for question with SpecificTypeId === 10 (open appointment program form)
        if ((question.Questions as any).SpecificTypeId === 10) {
          setCheckboxValues((prev) => ({ ...prev, [question.Questions.Id.toString()]: false }));
          setSelectedOptions((prev) => ({
            ...prev,
            [question.Questions.Id]: {
              options: [],
              answer: "0",
              min: null,
              touched: false,
              isValid: true,
            },
          }));
        }
      });
    }
  }, [reportQuestionsAndOptionData, GetReportQuestionsAndOptions]);

  useEffect(() => {
    if (!reportQuestionsAndOptionData?.length || !editAnswersData?.Questions?.length || !transformedOptions) return;

    const questionById = new Map(
      reportQuestionsAndOptionData.map((q) => [q.Questions.Id, q])
    );

    setSelectedOptions((prev) => {
      const next = { ...prev };
      editAnswersData.Questions.forEach((editQ) => {
        const question = questionById.get(editQ.QuestionId);
        if (!question) return;

        const questionId = editQ.QuestionId;
        const key = editQ.QuestionId.toString();
        const dataTypeId = editQ.DataTypesId;
        const existing = prev[key];

        if (dataTypeId === 1 && editQ.SelectedOptions?.length) {
          const availableOptions = transformedOptions[questionId] || [];
          const selectedOpts: TLabeledQuestionOption[] = [];

          editQ.SelectedOptions.forEach(({ OptionId, GroupId }) => {
            let found: TLabeledQuestionOption | undefined;
            for (const item of availableOptions) {
              if ("options" in item) {
                const optionInGroup = item.options.find((opt) => {
                  if (opt.Id !== OptionId) return false;
                  if (GroupId != null && opt.GroupId !== GroupId) return false;
                  return true;
                });
                if (optionInGroup) {
                  found = optionInGroup;
                  break;
                }
              } else {
                if (item.Id === OptionId && (GroupId == null || item.GroupId == null)) {
                  found = item;
                  break;
                }
              }
            }
            if (found) selectedOpts.push(found);
          });

          if (selectedOpts.length > 0) {
            const optionsToSet = filterLastOfEachGroup(selectedOpts);
            const minVal = optionsToSet.length > 0 ? (optionsToSet[0].min ?? null) : (question.Questions.OptionsCountMin ?? null);
            next[key] = {
              ...(existing ?? { options: [], isValid: false, min: question.Questions.OptionsCountMin ?? null, touched: false }),
              options: optionsToSet,
              touched: true,
              isValid: minVal != null ? (minVal ?? 0) <= optionsToSet.length : true,
            };
          }
        } else if ([2, 3].includes(dataTypeId) && (editQ.Answer != null && editQ.Answer !== undefined)) {
          next[key] = {
            ...(existing ?? { options: [], isValid: true, min: null, touched: false }),
            options: [],
            answer: editQ.Answer ?? "",
            min: 0,
            touched: true,
            isValid: true,
          };
        } else if (dataTypeId === 4 && editQ.Answer) {
          next[key] = {
            ...(existing ?? { options: [], isValid: true, min: null, touched: false }),
            options: [],
            answer: editQ.Answer ?? "",
            min: 0,
            touched: true,
            isValid: true,
          };
        }

        if (editQ.CheckboxValue !== undefined && editQ.CheckboxValue !== null) {
          next[key] = {
            ...(next[key] ?? { options: [], answer: "0", min: null, touched: false, isValid: true }),
            answer: editQ.CheckboxValue ? "1" : "0",
            touched: true,
            isValid: true,
          };
        }
      });
      return next;
    });

    setCheckboxValues((prev) => {
      const next = { ...prev };
      editAnswersData.Questions.forEach((editQ) => {
        if (editQ.CheckboxValue !== undefined && editQ.CheckboxValue !== null) {
          next[editQ.QuestionId.toString()] = editQ.CheckboxValue;
        }
      });
      return next;
    });

    setEditAnswersData(null);
  }, [
    reportQuestionsAndOptionData,
    editAnswersData,
    transformedOptions,
    showPaymentFeatures,
    paymentSession.serviceOptions,
    setPaymentService,
    setSessionPrice,
    setSelectedQuestionnaireScoreStatus,
  ]);

  useEffect(() => {
    if (
      showPaymentFeatures &&
      pendingEditPayment &&
      paymentSession.serviceOptions?.length
    ) {
      const serviceOption = paymentSession.serviceOptions.find(
        (opt) => opt.service?.serviceId === pendingEditPayment.companyServiceId
      );
      if (serviceOption) {
        setPaymentService({
          serviceId: pendingEditPayment.companyServiceId,
          serviceName: serviceOption.service.serviceName,
          price: pendingEditPayment.totalAmount,
        });
        setPendingEditPayment(null);
      }
    }
  }, [
    showPaymentFeatures,
    pendingEditPayment,
    paymentSession.serviceOptions,
    setPaymentService,
  ]);

  useEffect(() => {
    if (Object.keys(selectedOptions).length > 0) {
      setFormValid(isFormValid(selectedOptions));
    }
  }, [selectedOptions]);
  const checkedStyles = {
    border: "1px solid  #24a148",
    borderRadius: "4px",
    backgroundColor: "#f7fcf9",
  };

  const formatOptionLabel = (
    option: TGrouppedQuestionsOptions | TLabeledQuestionOption,
    { context }: { context: string }
  ) => {
    if ("GroupId" in option && option.Groups && context === "value") {
      return (
        <div>
          {option.Groups.Name} {option.label}
        </div>
      );
    } else if (context === "menu") {
      return <div>{option.label}</div>;
    } else {
      return <div>{option.label}</div>;
    }
  };

  const onSelectChange = (
    value: MultiValue<TLabeledQuestionOption>,
    { name }: ActionMeta<TLabeledQuestionOption>
  ) => {
    const newValue = filterLastOfEachGroup([...value]);
    const min =
      newValue.length > 0 ? (newValue[0].min ? newValue[0].min : null) : null;
    name &&
      setSelectedOptions((prev) => ({
        ...prev,
        [name]: {
          options: newValue,
          min,
          touched: true,
          isValid:
            prev[name]?.min !== null
              ? (prev[name]?.min ?? 0) <= newValue.length
              : true,
        },
      }));
  };


  const handlePaymentSectionSubmit = useCallback(async (paymentInfo: TUpdateQuestionnaireScoreTotalAmountRequest) => {
    try {
      // Use existing scoreUsersId or get a new one
      let idToUse = submittedScoreUsersId;

      if (!submittedScoreUsersId) {
        const answers: TInsertAllAnswersRequest[] = [{
          Id: "0",
          QuestionnaireId: reportInitialInfo?.QuestionnaireId?.toString() ?? "0",
          QuestionsId: "0",
          Answer: "",
          AnswerDate: null,
          QuestionsOptionsIds: "",
          Cycle: reportInitialInfo?.Cycle ?? null,
        }];

        // Submit minimal report to get questionnaireCompaniesScoreUsersId
        const response = await insertAllAnswers({
          answers,
          questionnaireCompaniesId:
            reportInitialInfo?.QuestionnaireCompaniesId ?? -1,
          targetUserGuid: user.Users.Guid || "0",
        }).unwrap();

        const scoreUsersId = response?.questionnaireCompaniesScoreUsersId;
        // Store the scoreUsersId for later use (payment)
        setSubmittedScoreUsersId(scoreUsersId);
        // Use the fresh value for the update call
        idToUse = scoreUsersId;
      }

      await updateQuestionnaireScoreTotalAmount({
        id: idToUse ?? 0,
        body: paymentInfo,
      }).unwrap();
      setSendQuestionnaireCompaniesScoreUpdate(false); //not send update twice

    } catch (error) {
      console.error("Failed to submit payment section:", error);
      throw error; // Re-throw to let PaymentSection handle the error display
    }
  }, [reportInitialInfo, user, admin, insertAllAnswers, updateQuestionnaireScoreTotalAmount, submittedScoreUsersId]);


  return (
    <section className={styles.section}>
      <BackArrowButton
        text={t("PREVIOUS_SCREEN")}
        onClick={onClose}
        position={"center"}
      />
      <h3 className={styles.title}>
        {t("REPORT_TITLE")} {user?.Users.FirstName} {user?.Users.LastName}
      </h3>
      {user && (
        <div className={styles.userInfo}>
          <UserInfo user={user} />
          <div>
            <div>
              <p
                className={`${userInfoStyles.user__label} ${userInfoStyles.form__subtitle}`}
              >
                {t("CYCLE_LABEL")}
              </p>
              <p className={userInfoStyles.user__text}>
                {reportInitialInfo?.Cycle ?? t(noDataLabel)}
              </p>
            </div>
            <div>
              <p
                className={`${userInfoStyles.user__label} ${userInfoStyles.form__subtitle}`}
              >
                {t("QUESTIONNAIRE_LABEL")}
              </p>
              <p className={userInfoStyles.user__text}>
                {reportInitialInfo?.DefaultName || t(noDataLabel)}
              </p>
            </div>
          </div>
        </div>
      )}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {showPaymentFeatures && (
            <PaymentSection
              onSubmit={handlePaymentSectionSubmit}
              patientGuid={user.Users.Guid}
              initialTotalAmount={initialPaymentFromEdit?.totalAmount}
              initialCompanyServiceId={initialPaymentFromEdit?.companyServiceId}
              initialQuestionnaireScoreStatusId={initialPaymentFromEdit?.questionnaireScoreStatusId ?? undefined}
            />
          )}
          <form className={styles.form}>
            <div className={styles.formHeader}>
              <h4 className={styles.formTitle}>{t("ACTION_REPORT_FORM_TITLE") || "Report Form"}</h4>
              {!isEditingExistingReport && (isLoadingQuestionnaires || questionnaireOptions.length > 0) && (
                <div className={styles.questionnaireSwitcher}>
                  <Select
                    inputId="questionnaire-switcher"
                    name="questionnaire-switcher"
                    aria-label={t("QUESTIONNAIRE_LABEL")}
                    classNamePrefix="select"
                    options={questionnaireOptions}
                    value={selectedQuestionnaireOption}
                    onChange={handleQuestionnaireChange}
                    isLoading={isLoadingQuestionnaires}
                    placeholder={t("SELECT_PLACEHOLDER")}
                    noOptionsMessage={() => t("NO_RESULTS")}
                    styles={questionnaireSwitcherStyles}
                  />
                </div>
              )}
            </div>
            {reportQuestionsAndOptionData &&
              reportQuestionsAndOptionData.length > 0 &&
              reportQuestionsAndOptionData
                .slice()
                .sort((a, b) => a.Questions.Seq - b.Questions.Seq)
                .map((question) => (
                  <div
                    key={question.Questions.Id}
                    className={`${styles.formField} ${(question.Questions.DataTypesId === 2) &&
                      styles.formField_type_wide
                      }`}
                    data-testid={`question-field-${question.Questions.Id}`}
                  >
                    <p
                      className={`${styles.text} ${selectedOptions[question.Questions.Id.toString()]
                        ?.touched &&
                        !selectedOptions[question.Questions.Id.toString()]
                          ?.isValid &&
                        styles.note_red
                        }`}
                    >
                      {question.Questions.OptionsCountMin ? "*" : ""}
                      {question.Questions.Desc}
                    </p>
                    {(question.Questions as any).SpecificTypeId === 10 ? (
                      <input
                        type="checkbox"
                        checked={checkboxValues[question.Questions.Id.toString()] ?? false}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setCheckboxValues((prev) => ({ ...prev, [question.Questions.Id.toString()]: checked }));
                          setSelectedOptions((prev) => ({
                            ...prev,
                            [question.Questions.Id.toString()]: {
                              options: [],
                              answer: checked ? "1" : "0",
                              min: null,
                              touched: true,
                              isValid: true,
                            },
                          }));
                        }}
                      />
                    ) : question.Questions.DataTypesId === 1 ? (
                      <CreatableSelect
                        isMulti={true}
                        name={question.Questions.Id.toString()}
                        placeholder={t("SELECT_PLACEHOLDER")}
                        options={transformServerOptions(
                          question.QuestionsOptions,
                          question.Questions.OptionsCountMax,
                          question.Questions.OptionsCountMin
                        )}
                        classNamePrefix="select"
                        formatCreateLabel={(inputText) =>
                          `${t("ADD_NEW_LABEL")} ${inputText} `
                        }
                        formatOptionLabel={formatOptionLabel}
                        onChange={onSelectChange}
                        value={
                          selectedOptions[question.Questions.Id.toString()]
                            ?.options
                        }
                        isOptionDisabled={() => {
                          const count = question?.Questions?.OptionsCountMax;
                          const IsNoScore = question?.Questions?.IsNoScore;
                          const groupId = question?.QuestionsOptions[0].GroupId;
                          if (
                            !selectedOptions[question.Questions.Id.toString()]
                          ) {
                            return false;
                          }
                          return (!groupId || IsNoScore) && count
                            ? selectedOptions[question.Questions.Id.toString()]
                              .options.length >= count
                            : false;
                        }}
                        styles={{
                          control: (baseStyles, state) => {
                            const name = state.selectProps.name;
                            const isValid = name
                              ? selectedOptions[name]?.isValid
                              : false;
                            // const isTouched = name
                            //   ? selectedOptions[name]?.touched
                            //   : false;
                            if (isValid) {
                              return { ...baseStyles, ...checkedStyles };
                            } else return baseStyles;
                          },
                        }}
                      />
                    ) : question.Questions.DataTypesId === 2 ? (

                      <textarea
                      ref={(el) => {
                        textAreaRefs.current[question.Questions.Id.toString()] = el;
                      }}
                        rows={1}
                        className={`${styles.textarea}`}
                        name={question.Questions.Id.toString()}
                        id={question.Questions.Id.toString()}
                        value={selectedOptions[question.Questions.Id.toString()]?.answer || ""}
                        onChange={(e) => {
                          setSelectedOptions((prev) => ({
                            ...prev,
                            [e.target.name]: {
                              options: [],
                              answer: e.target.value,
                              min: 0,
                              touched: true,
                              isValid: true,
                            },
                          }));
                        }}
                      />
                    ) : (
                      <input
                        type={
                          question.Questions.DataTypesId === 4
                            ? "date"
                            : question.Questions.DataTypesId === 3
                              ? "number"
                              : "text"
                        }
                        className={`${styles.input}`}
                        name={question.Questions.Id.toString()}
                        id={question.Questions.Id.toString()}
                        value={selectedOptions[question.Questions.Id.toString()]?.answer ?? ""}
                        onChange={(e) => {
                          setSelectedOptions((prev) => ({
                            ...prev,
                            [e.target.name]: {
                              options: [],
                              answer: e.target.value,
                              min: 0,
                              touched: true,
                              isValid: true,
                            },
                          }));
                        }}
                      />
                    )}
                    <p
                      className={`${styles.note} ${selectedOptions[question.Questions.Id.toString()]
                        ?.touched &&
                        !selectedOptions[question.Questions.Id.toString()]
                          ?.isValid &&
                        styles.note_red
                        }`}
                    >
                      {getSelectNote(
                        question.Questions.OptionsCountMin,
                        question.Questions.OptionsCountMax,
                        t
                      )}
                    </p>
                  </div>
                ))}
            <p className={styles.note}>
              {t("GROUP_OPTION_NOTE")}
            </p>
            <button
              type={"button"}
              className={`button ${styles.submitBtn} ${(isSending || !isPaymentValid) && styles.submitBtn_disabled
                }`}
              onClick={sendForm}
              disabled={isSending || !isPaymentValid}
            >
              {isSending ? t("SUBMITTING_LABEL") : t("SUBMIT_BUTTON")}
            </button>
            {/* Analyze report button: show only when AllowTherapistToSeeAiAnalysis !== 0 */}
            {/* {showPaymentFeatures && (
              <button
                type={"button"}
                className={`button ${styles.reanalyzeBtn} button_white hover`}
                data-testid="charge-user-button"
                onClick={handleOpenPaymentModal}
              >
                {pendingPayment
                  ? (t("ACTION_REPORT_EDIT_PAYMENT_BUTTON") || "Edit Payment")
                  : (t("ACTION_REPORT_CHARGE_USER_BUTTON") || "Charge User")}
              </button>
            )} */}
          </form>
        </>
      )}

      {/* <PaymentPopup
        isOpen={openPaymentModal}
        onClose={() => setOpenPaymentModal(false)}
        onSuccess={() => {
          setPendingPayment(null);
          setOpenPaymentModal(false);
          setOpenModal(true);
        }}
        user={user}
        userGuid={user.Users.Guid}
        appointmentProgram={savedTreatmentPlan as IAppointmentsProgram}
        treatmentPlanServiceId={treatmentPlanServiceId || undefined}
        questionnaireCompaniesScoreUsersId={submittedScoreUsersId}
        onPaymentPrepared={(paymentInfo) => {
          setPendingPayment(paymentInfo);
          setOpenPaymentModal(false);
        }}
      /> */}

      {openModal && (
        <Modal
          onClose={() => {
            setOpenModal(false);
            onClose();
          }}
        >
          <GeneralSuccessPopup
            onClose={() => {
              setOpenModal(false);
              onClose();
            }}
          />
        </Modal>
      )}
      {error && (
        <Modal onClose={() => setError(false)}>
          <ErrorPopup
            onClose={() => setError(false)}
            text={typeof error === "string" ? error : undefined}
          />
        </Modal>
      )}
    </section>
  );
}

export default ActionReport;
